import React from 'react'
import { cn } from '../../lib/cn'

/**
 * Encabezado de página: fondo verde suave con textura de puntos, ícono, título grande y
 * las acciones a la derecha. Es el mismo que usa Vales; está acá para que cada módulo
 * grande abra igual y no haya un encabezado distinto por pantalla.
 *
 * @param {{ icono?: React.ReactNode, eyebrow?: string, titulo: React.ReactNode,
 *           descripcion?: React.ReactNode, acciones?: React.ReactNode, estado?: React.ReactNode,
 *           className?: string }} props
 */
export function EncabezadoPagina({ icono, eyebrow, titulo, descripcion, acciones, estado, className }) {
  return (
    <header className={cn('encabezado-pagina-box relative overflow-hidden rounded-3xl border border-social-200/70 bg-gradient-to-br from-social-50 via-white to-emerald-50/70 px-5 py-5 sm:px-8 sm:py-6', className)}>
      <div aria-hidden="true" className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgb(22 163 74 / 0.16) 1.2px, transparent 0)',
          backgroundSize: '20px 20px',
          WebkitMaskImage: 'linear-gradient(to left, #000 0%, transparent 65%)',
          maskImage: 'linear-gradient(to left, #000 0%, transparent 65%)',
        }} />
      <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-20 h-56 w-56 rounded-full bg-social-300/30 blur-3xl" />

      <div className="relative flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-4">
          {icono && (
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-social-700 text-white shadow-lg shadow-social-700/25 sm:h-14 sm:w-14">
              <span className="h-6 w-6 sm:h-7 sm:w-7">{icono}</span>
            </span>
          )}
          <div className="min-w-0">
            {eyebrow && <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-social-700">{eyebrow}</p>}
            <h1 className="mt-0.5 text-2xl font-black tracking-tight text-ink sm:text-3xl">{titulo}</h1>
            {descripcion && <p className="mt-1 max-w-2xl text-sm leading-snug text-ink-soft">{descripcion}</p>}
            {estado && <div className="mt-1.5">{estado}</div>}
          </div>
        </div>
        {acciones && <div className="flex flex-wrap items-center gap-2">{acciones}</div>}
      </div>
    </header>
  )
}

export default EncabezadoPagina
